module.exports = __webpack_public_path__ + "img/05.cd111a2e.jpg";